import React from 'react';
import { Button, Icon } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getIntersections } from 'modules/userrequest';
import DatesListPicker from 'components/FormDate/DatesListPicker';
import SummaryDatesList from 'components/FormDate/SummaryDatesList';
import { getActivityExtent, getAllDates } from 'helpers/mapHelpers';

import styles from './controls.module.scss';

export class Dates extends React.Component {
  state = {
    openDatesListPicker: true,
  };

  componentDidUpdate (prevProps) {
    const { activity: { eventDates }, features } = this.props;
    const [dateStart, dateEnd] = getActivityExtent(getAllDates(eventDates));

    features.forEach(feature => {
      const hasEventDatesChanged = prevProps.activity.eventDates !== eventDates;
      if (hasEventDatesChanged && feature.properties.name !== 'LineString') {
        this.props.getIntersections(feature, dateStart, dateEnd);
      }
    });
  }

  /**
   * Update the redux store with updated dates
   * @param {object} eventDates - containing a list of objects `dates` and `recurrence`
   */
  onDatesAdd = eventDates => {
    const { activities: currentActivities, activity } = this.props;
    const activities = currentActivities.map(currentActivity => {
      if (currentActivity.uid !== activity.uid) {
        return currentActivity;
      }
      const { eventDates: currentEventDates } = currentActivity;
      const newUid = Math.max(-1, ...currentEventDates.map(({ uid }) => uid)) + 1;

      return {
        ...currentActivity,
        eventDates: [
          ...currentEventDates,
          { ...eventDates, uid: newUid },
        ],
      };
    });
    this.props.updateRequestProperties({ activities });
    this.setState({ openDatesListPicker: false });
  }

  /**
   * Remove a group of date from the redux store
   * @param {object} eventDates - containing `allDates` object
   */
  onDatesRemove = eventDates => {
    const { allDates } = eventDates;
    const { activities: currentActivities, activity } = this.props;
    const activities = currentActivities.map(currentActivity => {
      if (currentActivity.uid !== activity.uid) {
        return currentActivity;
      }
      return {
        ...currentActivity,
        eventDates: allDates,
      };
    });
    this.props.updateRequestProperties({ activities });
    if (allDates.length === 0) {
      this.setState({ openDatesListPicker: true });
    }
  }

  /**
   * Add and init a new Date
   */
  addDate = () => this.setState({ openDatesListPicker: true });

  render () {
    const { onDatesRemove, onDatesAdd, addDate } = this;
    const { eventDates } = this.props;
    const { openDatesListPicker } = this.state;

    return (
      <div className={styles.formActivity__dates}>
        <h3>Choix des dates</h3>

        <SummaryDatesList
          eventDates={eventDates}
          onRemove={value => onDatesRemove(value)}
        />
        {openDatesListPicker
          ? <DatesListPicker onChange={value => onDatesAdd(value)} />
          : (
            <Button type="dashed" onClick={addDate}>
              <Icon type="plus" /> Ajouter une date
            </Button>
          )
        }
      </div>
    );
  }
}

const DispatchToProps = dispatch => bindActionCreators({
  getIntersections,
}, dispatch);

export default connect(null, DispatchToProps)(Dates);



// WEBPACK FOOTER //
// ./src/components/Form/FormActivity/Controls/ControlDates.js